<template>
  <div class="c-searchBottomDisclaimer">
    <div class="c-disclaimerTextWrapper">
      <div
        class="c-disclaimerText"
        :class="{ 'c-disclaimerText-folded': !disclaimerTextExpanded }"
        ref="disclaimerText"
      >
        <!-- 占いのみなのでいったんベタ書き、占い以外に必要になった場合に拡張する -->
        <h2>
          <strong>占いで掲載している情報について</strong>
        </h2>
        <p>占いサービスは娯楽を目的としたものであり、占いの結果および占いに伴う施術行為について、その効果、信頼性、正確性、完全性、有効性、特定の目的への適合性、実現性等を当社が保証するものではありません。</p>
        <p>サービスの結果をどのように利用するかは、お客様ご自身の自己責任において判断をお願いいたします。</p>
        <p>占いの結果およびその内容を踏まえておこなったお客様の行動により生ずる一切の損害について、当社および情報の提供者は一切責任を負いかねます。</p>
      </div>
      <a
        class="c-disclaimerTextWrapper_expandButton"
        :class="{ 'c-disclaimerTextWrapper_expandButton-folded': !disclaimerTextExpanded }"
        @click="disclaimerTextExpanded = !disclaimerTextExpanded"
        v-if="isSP || isTB"
      >
        {{ disclaimerTextExpanded ? '閉じる' : 'すべて見る' }}
        <coconala-icon
          :name="disclaimerTextExpanded ? 'chevron-up': 'chevron-down'"
          size="10px"
        />
      </a>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ServiceSearchBottomDisclaimer',
  data() {
    return {
      disclaimerTextExpanded: true
    }
  },
  computed: {
    ...mapGetters('ui', ['isPC', 'isTB', 'isSP'])
  },
  mounted() {
    let disclaimerTextHeight = 0
    const disclaimerText = this.$refs.disclaimerText
    if (disclaimerText) {
      disclaimerTextHeight = disclaimerText.clientHeight
    }
    this.$nextTick(() => (this.disclaimerTextExpanded = disclaimerTextHeight < 113 || this.isPC))
  }
}
</script>
<style lang="scss" scoped>
.c-searchBottomDisclaimer {
  margin-top: 40px;
}
// DBから取得したhtmlに対してのCSS適用
.c-disclaimerTextWrapper {
  a {
    @include link-effect;
  }
}
.c-disclaimerText {
  h2 {
    margin-bottom: 8px;
    strong {
      color: $color-gray-900;
      font-size: 20px;
    }
  }
  p {
    font-size: 13px;
  }
}

@media (max-width: breakpoint(Search, M)) {
  .c-disclaimerTextWrapper {
    padding: 0 10px;
    &_expandButton {
      position: relative;
      display: block;
      text-align: center;
      font-size: 14px;
      line-height: 40px;
      &-folded {
        &::before {
          position: absolute;
          top: -20px;
          left: 0;
          z-index: 10;
          width: 100%;
          height: 20px;
          background: linear-gradient(rgba(255, 255, 255, 0) 0, $color-white 20px);
          content: '';
        }
      }
    }
  }
  .c-disclaimerText {
    &-folded {
      overflow: hidden;
      max-height: 113px;
    }
    h2 {
      strong {
        font-size: 16px;
      }
    }
  }
}
</style>
